'use client';

import { memo } from 'react';
import { useTranslation } from 'next-i18next';
import { CandidateTag } from './CandidateTag';

interface CandidateCardTagsProps {
  /** href shown in the browser status bar, same as the card title link. */
  href?: string;
}

/**
 * @description Tag badges for candidate sidebar cards (alerts, last experience, next jobs).
 *
 * Kept intentionally separate from the company job card `Tags` component because
 * candidate tags represent search/discovery actions and will evolve independently
 * (e.g. job-count indicators, alert freshness, etc.) rather than applicant statuses.
 */
const CandidateCardTags = ({ href }: CandidateCardTagsProps) => {
  const { t } = useTranslation('common');

  return (
    <div className="mt-2 flex flex-wrap gap-1">
      <CandidateTag
        label={t('my-jobs.card.tags.new') || 'New'}
        href={href}
        className="text-ink hover:bg-ink/10"
      />
    </div>
  );
};

export const MemoizedCandidateCardTags = memo(CandidateCardTags);
